export default __webpack_public_path__ + "static/media/auteuil4.5775dd2a.jpg";